import { render } from "./CreateFileInsideFeatureVideoSection.vue?vue&type=template&id=48eee52f"
import script from "./CreateFileInsideFeatureVideoSection.vue?vue&type=script&lang=js"
export * from "./CreateFileInsideFeatureVideoSection.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "48eee52f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48eee52f', script)) {
    api.reload('48eee52f', script)
  }
  
  module.hot.accept("./CreateFileInsideFeatureVideoSection.vue?vue&type=template&id=48eee52f", () => {
    api.rerender('48eee52f', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/Video/CreateFileInsideFeatureVideoSection.vue"

export default script